
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SessionTypeResponse } from "../../models/dtos";

export const sessionTypesApi = createApi({
  reducerPath: 'sessionTypesApi',
  baseQuery: baseAuthQuery('SessionTypes'),
  tagTypes: ['SessionType'],
  endpoints: (builder) => ({
    getSessionTypes: builder.query<ApiResponse<SessionTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['SessionType'],
    }),
    getSessionTypeById: builder.query<ApiResponse<SessionTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SessionType'],
    }),
    updateSessionType: builder.mutation<ApiResponse<SessionTypeResponse>, Partial<SessionTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SessionType'],
    }),
    deleteSessionType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SessionType'],
    }),
  }),
});
